import React,{useEffect} from 'react';
import { useContentPlayer } from '../../context/ContentPlayerContext';
import ContentPlayerModal from './ContentPlayerModal';

const ContentPlayerModalContainer = () => {
  const { modalState, closeContentPlayer } = useContentPlayer();
  useEffect(() => {
    console.log('Modal state changed:', modalState);
  }, [modalState]);
  return (
    <>
       {modalState.open && (
        <ContentPlayerModal
          open={modalState.open}
          onClose={closeContentPlayer}
          courseId={modalState.courseId}
          contentId={modalState.contentId}
          returnUrl={modalState.returnUrl}
        />
      )}
    </>
  );
};

export default ContentPlayerModalContainer;